import { AxiosError } from 'axios';
import { whoAmIUrl } from 'constants/urls';
import { MantaCareUser } from 'context/UserContext/types';
import { useSWRAxios } from 'hooks/useSWRAxios';

export const useCurrentUser = ({ onSuccess }: { onSuccess?: (user: MantaCareUser) => void } = {}) => {
    const url = whoAmIUrl();
    const { data, ...restProperties } = useSWRAxios<MantaCareUser, AxiosError<{ message: string }>>(url, {
        onSuccess: data => onSuccess?.(data)
    });

    return {
        ...restProperties,
        user: data
    };
};
